import { Slider } from "components/common/Slider/Slider";
import { Translate } from "components/common/Translate/Translate";
import { usePercentage } from "./usePercentage";

export const Percentage = () => {
    const { handleChange, percentage, image } = usePercentage();

    return (
        <div className="flex flex-col gap-2 mb-2">
            <div className="capitalize font-semibold" data-testid={`percentage-label`}>
                <Translate keyName="size" />
            </div>
            <div className="flex items-center dark:bg-darkSurface-200 gap-4 border border-irGray-200 dark:border-darkSurface-400 px-4 pt-4 pb-5 rounded-xl">
                <div className="flex-grow">
                    <Slider
                        min={0}
                        max={200}
                        defaultValue={percentage}
                        handleChange={handleChange}
                        step={1}
                        testId="percentage-slider"
                    />
                </div>
                <div className="mt-1" data-testid={`percentage-value`}>
                    {percentage}%
                </div>
            </div>
            <div className="text-sm text-irGray-500" data-testid={`percentage-output`}>
                <Translate
                    keyName="percentage-helper"
                    variables={{
                        percentage,
                    }}
                />
                {`(${Math.round((image.original.width * percentage) / 100)} X ${Math.round(
                    (image.original.height * percentage) / 100,
                )} px)`}
            </div>
        </div>
    );
};
